var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBSupplier(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-supplier",
    x: 0,
    y: 0,
    width: 23.998,
    height: 23.998,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "person-carry-box.svg",
    d: "M11.044,13.336c-0.567,-0 -1.095,-0.288 -1.399,-0.766l-0.574,-0.889l0,3.459l1.049,0.825c0.337,0.266 0.558,0.649 0.62,1.074l0.62,4.331c0.079,0.551 -0.303,1.064 -0.858,1.144c-0.555,0.08 -1.064,-0.303 -1.144,-0.858l-0.597,-4.194l-3.774,-2.963c-0.559,-0.439 -0.887,-1.115 -0.887,-1.828l0,-3.494c0,-1.355 1.098,-2.453 2.453,-2.453c1.079,-0 2.087,0.55 2.67,1.459l2.015,3.134l0.736,0l0,-4.568c0,-0.74 0.598,-1.338 1.338,-1.338l5.249,0c0.74,0 1.337,0.598 1.337,1.338l0,5.249c0,0.74 -0.597,1.338 -1.337,1.338l-7.517,-0Zm2.949,-2.019l3.887,0l-0,-3.887l-3.887,-0l-0,3.887Zm-7.44,-2.575c-0.241,0 -0.434,0.194 -0.434,0.435l-0,3.498c-0,0.094 0.041,0.182 0.117,0.238l0.817,0.641c-0,0 -0,-4.698 -0,-4.698c-0.153,-0.072 -0.325,-0.114 -0.5,-0.114Zm0.853,-7.268c1.094,0 1.993,0.9 1.993,1.994c0,1.093 -0.899,1.993 -1.993,1.993c-1.094,0 -1.994,-0.9 -1.994,-1.993c0,-1.094 0.9,-1.994 1.994,-1.994Zm-3.306,20.039l0,-6.058c0,-0.009 0.006,-0.018 0.014,-0.022c0.009,-0.004 0.019,-0.003 0.027,0.003c0.02,0.016 0.045,0.037 0.065,0.053l1.903,1.497c0.006,0.005 0.01,0.012 0.01,0.02l-0,4.507c-0,0.559 -0.45,1.009 -1.01,1.009c-0.559,0 -1.009,-0.45 -1.009,-1.009Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBSupplier);
export default __webpack_public_path__ + "static/media/iconB-supplier.27d8ff8367b199f7c10ff6d018aa2268.svg";
export { ForwardRef as ReactComponent };